import React from "react";
import carIconLogo from './carIconLogo.svg'

function carIcon(){
    return(
        <img src={carIconLogo} width='60px' height='47px' alt = "white outline of car and carkey"/>
    )
}
export default carIcon